import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {promoCodesService} from "../../../services/settings-services";


const initialState = {
    promoCodesArray: [],
    status: null,
    error: null,
    trigger: 0,
}

const getAllPromoCodes = createAsyncThunk(
    'promoCodesSlice/getAllPromoCodes',
    async (_, {rejectWithValue}) => {
        try {
            return  await promoCodesService.getAllPromoCodes();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const promoCodesSlice = createSlice({
    name: "promoCodesSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllPromoCodes.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllPromoCodes.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.promoCodesArray = action.payload;
            })
            .addCase(getAllPromoCodes.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: promoCodesReducer, actions} = promoCodesSlice;
const promoCodesActions = {
    ...actions,
    getAllPromoCodes
}

export {
    promoCodesReducer,
    promoCodesActions,
}